import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'de'],

  // Always prefix routes with the locale as in legacy Job-Portal
  localePrefix: 'always',

  // Used when no locale matches
  defaultLocale: 'de',

  // Kein `Link: <…>; rel="alternate"; hreflang="…"`-Header.
  //
  // next-intl kennt die Firma nicht — sie steckt in `?companyId=` bzw. in der Domain — und
  // baut den Header deshalb aus dem nackten Pfad: /de, /en und /  als x-default. Das sind
  // die firmenlosen Fehlerseiten. Google wertet HTTP-Header und HTML-Tags gleichrangig aus
  // und bekäme damit zwei widersprüchliche hreflang-Cluster pro Seite. Die korrekten
  // Alternates stehen im HTML (siehe util/buildPageMetadata.ts).
  alternateLinks: false,
});

export type Locale = (typeof routing.locales)[number];
export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);
